import { all, fork, put, takeEvery, takeLatest, call } from 'redux-saga/effects';
import * as constants from './constants';
import { commodityCategory, createCommodityCategory, updateCommodityCategory, deleteCommodityCategory } from './api';
import { toast } from 'react-toastify';

function* getCommodityCategorySaga(action) {
    try {
        const response = yield call(commodityCategory, action.payload);
        if (response.data.status === 200) {
            yield put({
                type: constants.COMMODITY_CATEGORY_GET_SUCCESS,
                payload: { ...response.data },
            });
        } else {
            yield put({
                type: constants.COMMODITY_CATEGORY_GET_ERROR,
                payload: { ...response.data },
            });
        }
    } catch (error) {
        yield put({
            type: constants.COMMODITY_CATEGORY_GET_ERROR,
            payload: error,
        });
    }
}

function* createCommodityCategorySaga(action) {
    try {
        const response = yield call(createCommodityCategory, action.payload);
        if (response.data.status === 200) {
            yield put({
                type: constants.COMMODITY_CATEGORY_POST_SUCCESS,
                payload: { ...response.data },
            });
            toast.success(response.data.message);
        } else {
            yield put({
                type: constants.COMMODITY_CATEGORY_POST_ERROR,
                payload: { ...response.data },
            });
            toast.error(response.data.message);
        }
    } catch (error) {
        yield put({
            type: constants.COMMODITY_CATEGORY_POST_ERROR,
            payload: error,
        });
        toast.error('Failed to create category');
    }
}

function* updateCommodityCategorySaga(action) {
    try {
        const response = yield call(updateCommodityCategory, action.payload);
        if (response.data.status === 200) {
            yield put({
                type: constants.COMMODITY_CATEGORY_UPDATE_SUCCESS,
                payload: { ...response.data },
            });
            toast.success(response.data.message);
        } else {
            yield put({
                type: constants.COMMODITY_CATEGORY_UPDATE_ERROR,
                payload: { ...response.data },
            });
            toast.error(response.data.message);
        }
    } catch (error) {
        yield put({
            type: constants.COMMODITY_CATEGORY_UPDATE_ERROR,
            payload: error,
        });
        toast.error('Failed to update category');
    }
}

function* deleteCommodityCategorySaga(action) {
    try {
        const response = yield call(deleteCommodityCategory, action.payload);
        if (response.data.status === 200) {
            yield put({
                type: constants.COMMODITY_CATEGORY_DELETE_SUCCESS,
                payload: { ...response.data },
            });
            toast.success(response.data.message);
        } else {
            yield put({
                type: constants.COMMODITY_CATEGORY_DELETE_ERROR,
                payload: { ...response.data },
            });
            toast.error(response.data.message);
        }
    } catch (error) {
        yield put({
            type: constants.COMMODITY_CATEGORY_DELETE_ERROR,
            payload: error,
        });
        toast.error('Failed to delete category');
    }
}

export function* watchGetCommodityCategory() {
    yield takeLatest(constants.COMMODITY_CATEGORY_GET, getCommodityCategorySaga);
}

export function* watchCreateCommodityCategory() {
    yield takeEvery(constants.COMMODITY_CATEGORY_POST, createCommodityCategorySaga);
}

export function* watchUpdateCommodityCategory() {
    yield takeEvery(constants.COMMODITY_CATEGORY_UPDATE, updateCommodityCategorySaga);
}

export function* watchDeleteCommodityCategory() {
    yield takeEvery(constants.COMMODITY_CATEGORY_DELETE, deleteCommodityCategorySaga);
}

function* commodityCategorySaga() {
    yield all([
        fork(watchGetCommodityCategory),
        fork(watchCreateCommodityCategory),
        fork(watchUpdateCommodityCategory),
        fork(watchDeleteCommodityCategory),
    ]);
}

export default commodityCategorySaga;
